import { Component } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { AuthService } from '../../../core/services/auth.service'
import { CommonModule } from '@angular/common'
import { filter } from 'rxjs/operators'
import { DBSearchComponent } from 'src/app/pages/atleti-metrics/components/db-search/db-search.component'

@Component({
    selector: 'tabs-component',
    imports: [
      MatTabsModule, 
      RouterModule, 
      CommonModule, 
      DBSearchComponent
    ],
    standalone: true,
    templateUrl: './tabs.component.html',
    styleUrl: './tabs.component.css'
})
export class TabsComponent {
  constructor(
    private router: Router, 
    public auth: AuthService
  ) {}

  links = [
    { location: 'atscore', label:'AT Score', guard: !this.auth.isLoggedIn() },
    { location: 'stats', label: 'Buscador', guard: !this.auth.isLoggedIn() },
    { location: 'matches', label: 'Partidos', guard: !this.auth.isEditor(), if: !this.auth.isEditor() },
    { location: 'cantera', label: 'Cantera', guard: false }
  ]
  activeLink = this.links[2]

  ngOnInit() {
    let href = this.router.url
    const index = this.links.map(e => e.location).indexOf(href.substring(4))
    this.activeLink = this.links[index]
    
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      const href = event.urlAfterRedirects
      const index = this.links.map(e => e.location).indexOf(href.substring(4))
      this.activeLink = this.links[index]
    })

    this.auth.userLoggedEvent.subscribe(()=>{
      this.reloadLinks()
    })
  }

  reloadLinks(){
    this.links = [
    { location: 'atscore', label:'AT Score', guard: !this.auth.isLoggedIn() },
    { location: 'stats', label: 'Buscador', guard: !this.auth.isLoggedIn() },
    { location: 'matches', label: 'Partidos', guard: !this.auth.isEditor(), if: !this.auth.isEditor() },
    { location: 'cantera', label: 'Cantera', guard: false }
    ]
  }
}
